import React from 'react';
import css from "../Components/Navbar.module.css";
import {NavbarItemTablet} from "../Components/NavbarItemTablet";

const NavbarDesktop = ({items=[]}) => {
    const mainItems = items.filter(item => item.group !== "footer");
    const footerItems = items.filter(item => item.group === "footer");

    return (
            <div className={css.Navbar}>
                <div className={css.main_group}>
                    {mainItems.map((item, index) =>
                        <NavbarItemTablet key={index}
                                          isArrowBack={true}
                                          item={item}
                                          tooltipShow={true}
                                          depthLevel={0}
                        />)}
                </div>
                {footerItems.length > 0 && (
                    <div className={css.footer_group}>
                        {footerItems.map((item, index) =>
                            <NavbarItemTablet key={`footer-${index}`}
                                              isArrowBack={true}
                                              item={item}
                                              tooltipShow={true}
                                              depthLevel={0}
                            />)}
                    </div>
                )}
            </div>
    );
};

export  {NavbarDesktop};